<template>
  <a :href="link ?? ''" target="_blank" class="h-20 flex items-center border border-light-200 rounded-xl text-light-950 dark:border-dark-600" :class="[ metadata?.title ? 'bg-white dark:bg-dark-800 dark:text-dark-50' : 'bg-charcoal-100 dark:bg-charcoal-900 dark:text-charcoal-600' ]" v-show="link && !isError">
    <div class="grow p-3">
      <p class="line-clamp-1 break-all font-bold">{{ metadata?.title }}</p>
      <p class="line-clamp-2 text-sm" style="overflow-wrap: anywhere;">{{ metadata?.description }}</p>
    </div>
    <div class="bg-urchin-100 size-14 overflow-hidden rounded-md shrink-0 mr-2.5 relative" v-if="metadata?.image || metadata?.['og:image']">
      <img :src="metadata.image || metadata['og:image']" class="absolute w-full h-full top-0 left-0 object-cover" />
    </div>
  </a>
</template>

<script lang="ts" setup>
import { metadataGetAPI } from '@/api/metadata'

const props = defineProps<{
  link?: string
}>()

const { link } = toRefs(props)
const isError = ref(false)

const metadata = ref()
watch(link, async () => {
  if (link.value) {
    try {
      metadata.value = await metadataGetAPI(link.value)
      if (!metadata.value?.title) isError.value = true
    } catch (e) {
      isError.value = true
      console.error(e)
    }
  }
}, { immediate: true })
</script>